import React from "react";
import { IStyledSVGIconProps, StyledSVGIcon } from "./icon.style";

export const RequestSomethingIcon: React.FC<IStyledSVGIconProps> = (
  props
) => {
  return (
    <StyledSVGIcon
      version="1.1"
      id="icons"
      xmlns="http://www.w3.org/2000/svg"
      xlinkHref="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="23.009" 
      height="23.009" 
      viewBox="0 0 23.009 23.009"
      style={{ enableBackground: "new 0 0 48 48;" }}
      xmlSpace="preserve"
      {...props}
    >
      <g id="Group_649" data-name="Group 649" transform="translate(-555.223 -405.883)">
        <path id="Serviceaccount" d="M0,11.5A11.5,11.5,0,1,0,11.5,0,11.48,11.48,0,0,0,0,11.5ZM11.5,1.769A9.7,9.7,0,0,1,21.241,11.5,9.851,9.851,0,0,1,17.7,19.028c.773-.754-2.894,2.17-6.2,2.078-2.886-.086-6.4-2.36-6.2-2.168A9.8,9.8,0,0,1,3.981,5.222,10.077,10.077,0,0,1,11.5,1.769Z" transform="translate(555.223 405.883)" fill="#007bc3"/>
        <g id="Approved_PersonCheck3" transform="translate(559.026 410.085)">
          <path id="Path_380" data-name="Path 380" d="M5,10.829a2.165,2.165,0,0,0,2.069,2.238H7.11a2.136,2.136,0,0,0,2.112-2.2v-.633A2.165,2.165,0,0,0,7.152,8H7.11A2.163,2.163,0,0,0,5,10.2Z" transform="translate(-2.887 -4.176)" fill="#007bc3"/>
          <path id="Path_381" data-name="Path 381" d="M24.757,4.378a.4.4,0,0,0-.422.422V6.912h-5.49V1.845h4.223a.4.4,0,0,0,.422-.422A.4.4,0,0,0,23.068,1H18V7.757h7.179V4.8A.4.4,0,0,0,24.757,4.378Z" transform="translate(-10.578 -0.555)" fill="#007bc3"/>
          <path id="Path_382" data-name="Path 382" d="M28.258.053A.408.408,0,0,0,27.666.1h0L23.95,4.487,22.768,3.431a.413.413,0,0,0-.591.084.4.4,0,0,0,.042.549l1.816,1.647L28.3.644A.511.511,0,0,0,28.258.053Z" transform="translate(-12.938 0.055)" fill="#007bc3"/>
          <path id="Path_383" data-name="Path 383" d="M10.191,18.869c-.127,0-.224.193-.309.235-.76.633-1.436,1.182-1.858,1.52a6.349,6.349,0,0,0-2.492-.76H2.956A2.661,2.661,0,0,0,0,22.4v2.112c0,1.309.633,2.112,1.689,2.112h.845v-3.8H1.689v2.956c-.718,0,1.373.991,5.068,1.991V23.5l.549.253A1.229,1.229,0,0,0,8.784,23.5l1.267-1.267c1.394-1.309,1.014-2.407.465-3.125C10.389,19.061,10.317,18.869,10.191,18.869Z" transform="translate(0 -10.419)" fill="#007bc3"/>
        </g>
      </g>    
    </StyledSVGIcon>
  );
};
